var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfileicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1",
    transform: "translate(-1874.201 -2051.374)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1830",
    "data-name": "Path 1830",
    d: "M3383,2434.924h15.706s4.36.285,5.232-6.1h-12.5l5.526-19.488-6.113-2.331Z",
    transform: "translate(-1497.343 -352.727)",
    fill: "#fefefe",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_398498120",
    transform: "translate(1874.201 2051.374)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1831",
    "data-name": "Path 1831",
    d: "M1893.477,2058.83a7.221,7.221,0,0,1,5.961,2.3c4.938,5.435,2.173,14.926-4.473,15.688-4.725.546-8.174-3.749-8.5-8.165C1886.1,2063.591,1889.193,2059.352,1893.477,2058.83Zm16.1,25.966a14.657,14.657,0,0,0,1.512-2.063,20.639,20.639,0,0,0-5.819-27.949,19.671,19.671,0,0,0-22.089-.032,20.682,20.682,0,0,0-7.15,25.556,20.4,20.4,0,0,0,1.268,2.385,11.773,11.773,0,0,0,1.528,2.063,8.171,8.171,0,0,1,3.394-5.62,16.135,16.135,0,0,1,4.4-2.385c1.134-.4,1.016-.417,1.449.048a9.6,9.6,0,0,0,2.725,1.782,8.674,8.674,0,0,0,8.741-1.108c.244-.177.425-.337.63-.506a7.233,7.233,0,0,1,.575-.53,14.1,14.1,0,0,1,3.1,1.2C1906.5,2079.022,1909.163,2081.222,1909.573,2084.8Z",
    transform: "translate(-1874.201 -2051.374)",
    fill: "#2469f5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1832",
    "data-name": "Path 1832",
    d: "M3435.475,2974.415c-4.434.515-7.637,4.7-7.254,9.693.334,4.359,3.9,8.6,8.794,8.06,6.879-.753,9.74-10.121,4.629-15.487A7.662,7.662,0,0,0,3435.475,2974.415Z",
    transform: "translate(-3416.224 -2966.848)",
    fill: "#fcfcfc",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1833",
    "data-name": "Path 1833",
    d: "M2469.68,5173.008c7.473,6.431,13-.008,13-.008,8.8,2.478,8.743,8.484,8.743,8.484-15.241,14.826-30.427-.041-30.427-.041S2461.023,5175.763,2469.68,5173.008Z",
    transform: "translate(-582.017 -3096.689)",
    fill: "#fefefe",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileicon);
export default __webpack_public_path__ + "static/media/profileicon.3122a70cd664b20f3294a9fa8f09da00.svg";
export { ForwardRef as ReactComponent };